import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Input, Select, Space, Switch, Table, Tag, message, Typography } from 'antd';
import { paymentAPI } from '../services/api';
import { PaymentConfigItem } from '../types';
import { detectSiteMode } from '../utils/site';

const { Title, Text } = Typography;

const AdminPaymentConfigPage: React.FC = () => {
  const [configs, setConfigs] = useState<PaymentConfigItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [adminToken, setAdminToken] = useState('ADMIN_TOKEN');
  const [form] = Form.useForm();

  const site = detectSiteMode();

  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const res = await paymentAPI.getPaymentConfig();
      setConfigs(res.data.paymentConfigs || []);
    } catch {
      message.error('获取支付配置失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  const handleSave = async (values: any) => {
    try {
      await paymentAPI.updatePaymentConfig(values, adminToken);
      message.success('支付配置已保存');
      form.resetFields();
      fetchConfigs();
    } catch {
      message.error('保存失败，请检查 Admin Token');
    }
  };

  return (
    <div>
      <Title level={3}>支付配置管理</Title>
      <Card style={{ marginBottom: 16 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Text type="secondary">当前站点：{site === 'CN' ? '中国站 (CN)' : 'Global 站 (GLOBAL)'}。如需配置另一站点，请切换对应子域名进入后台。</Text>
          <Input value={adminToken} onChange={(e) => setAdminToken(e.target.value)} placeholder="x-admin-token" />
        </Space>
      </Card>

      <Card title="新增/更新支付方式" style={{ marginBottom: 16 }}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="provider" label="支付提供方" rules={[{ required: true }]}>
            <Select
              options={[
                { label: 'ALIPAY_QR', value: 'ALIPAY_QR' },
                { label: 'WECHAT_QR', value: 'WECHAT_QR' },
                { label: 'PAYPAL', value: 'PAYPAL' },
              ]}
            />
          </Form.Item>
          <Form.Item name="display_name" label="展示名称" rules={[{ required: true }]}>
            <Input placeholder="如：支付宝 / WeChat Pay / PayPal" />
          </Form.Item>
          <Form.Item name="qr_image_url" label="二维码地址">
            <Input placeholder="/payment-qr/alipay_qr.svg" />
          </Form.Item>
          <Form.Item name="pay_link" label="支付链接（可选）">
            <Input placeholder="https://..." />
          </Form.Item>
          <Form.Item name="enabled" label="启用" valuePropName="checked" initialValue>
            <Switch />
          </Form.Item>
          <Button type="primary" htmlType="submit">保存</Button>
        </Form>
      </Card>

      <Card title="当前生效配置">
        <Table
          rowKey="id"
          loading={loading}
          dataSource={configs}
          pagination={false}
          columns={[
            { title: 'Tenant', dataIndex: 'tenant', render: (v) => <Tag>{v}</Tag> },
            { title: 'Provider', dataIndex: 'provider' },
            { title: '名称', dataIndex: 'display_name' },
            { title: '二维码', dataIndex: 'qr_image_url', render: (v) => v || '-' },
            { title: '链接', dataIndex: 'pay_link', render: (v) => v || '-' },
            { title: '启用', dataIndex: 'enabled', render: (v) => (v ? '是' : '否') },
          ]}
        />
      </Card>
    </div>
  );
};

export default AdminPaymentConfigPage;
